<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Consignments',
        route: { name: 'freight-consignments-v3' }
      }
    }
  }
}
</script>
